<template>
  <div>
    <el-tooltip v-if="content && !loaded" effect="dark" placement="right">
      <span style="color: #0151d1; cursor: pointer" @click="handleDecode">
        {{ content }}
      </span>
      <div slot="content">点击查看完整信息</div>
    </el-tooltip>
    <span v-else style="color: #0151d1">{{ content }}</span>
  </div>
</template>

<script>
export default {
  name: 'common-decode',
  props: {
    // 解密类型: 身份证号、手机号、邮箱、地址、银行卡号
    type: {
      type: Number,
    },
    // 加密值
    value: {
      type: String,
      default: '',
    },
    // 解密token
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: '',
      loaded: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.content = val
        this.loaded = false
      },
      immediate: true,
    },
  },
  methods: {
    handleDecode() {
      if (this.loaded) return
      const params = {
        type: this.type,
        token: this.token,
      }
      this.fetch
        .post('decodeByToken', params)
        .then((res) => {
          this.content = res.text || ''
          this.loaded = true
        })
        .catch(() => {
          this.$message.error('获取失败，请重试')
        })
    },
  },
}
</script>